import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./i18n.tsx";
import {
  bootstrapQueryClient,
  PersistedDashboardQueryCacheSync,
  queryClient,
} from "@/lib/queryClient";
import { ProgramProvider } from "./programs/context/programContext.tsx";
import { TypeProjectProvider } from "./programs/context/typeProgramContext.tsx";

const root = ReactDOM.createRoot(document.getElementById("root")!);

async function bootstrapApp() {
  await bootstrapQueryClient();

  root.render(
    // <React.StrictMode>
    <BrowserRouter future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
      <QueryClientProvider client={queryClient}>
        <PersistedDashboardQueryCacheSync />
        <ProgramProvider>
          <TypeProjectProvider>
            <App />
            {process.env.NODE_ENV === "development" && <ReactQueryDevtools />}
          </TypeProjectProvider>
        </ProgramProvider>
      </QueryClientProvider>
    </BrowserRouter>
    // </React.StrictMode>
  );
}

void bootstrapApp();
